import type { Manga } from "@/mocks/manga";
import MangaCard from "@/components/common/MangaCard";
import SectionHeader from "@/components/common/SectionHeader";

export default function MangaGridSection({
  title,
  subtitle,
  moreTo,
  icon,
  items,
}: {
  title: string;
  subtitle?: string;
  moreTo: string;
  icon: string;
  items: Manga[];
}) {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <SectionHeader title={title} subtitle={subtitle} moreTo={moreTo} icon={icon} />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5" data-product-shop="manga-list">
          {items.map((m) => (
            <MangaCard key={m.id} manga={m} />
          ))}
        </div>
      </div>
    </section>
  );
}